export default {"src":"/_next/static/media/Chloe.b19d9180.svg","height":45,"width":44,"blurWidth":0,"blurHeight":0};